import { InjectionToken } from '@angular/core';

export interface ApdLoaderConfig {
  ignorePatterns: Array<string | RegExp>;
  delayLoadbar?: number;
}

export const LOADER_CONFIG = new InjectionToken<ApdLoaderConfig>('loader.config');
